import React, { useEffect, useState } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { PainSection } from '../components/sales/PainSection';
import { RevealSection } from '../components/sales/RevealSection';
import { OfferSection } from '../components/sales/OfferSection';
import { BonusSection } from '../components/sales/BonusSection';
import { StackSummary } from '../components/sales/StackSummary';
import { PricingCTA } from '../components/sales/PricingCTA';
import { FloatingCTA } from '../components/sales/FloatingCTA';
import { Footer } from '../components/sales/Footer';
import { CountdownBanner } from '../components/sales/CountdownBanner';
import { SocialProofToast } from '../components/sales/SocialProofToast';
import { initMetaPixel } from '../utils/metaPixel';
export function SalesPage() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const BASE_PRICE = 17.27;
  const BUMP_PRICE = 9;
  const totalPrice = BASE_PRICE + (bump1 ? BUMP_PRICE : 0) + (bump2 ? BUMP_PRICE : 0);
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <CountdownBanner data-id="element-410" />
      <main className="w-full font-body pt-10" lang="es" data-id="element-411">
        <HeroSection data-id="element-412" />
        <PainSection data-id="element-413" />
        <RevealSection data-id="element-414" />
        <OfferSection data-id="element-415" />
        <BonusSection data-id="element-416" />
        <StackSummary data-id="element-417" />
        <PricingCTA bump1={bump1} bump2={bump2} setBump1={setBump1} setBump2={setBump2} totalPrice={totalPrice} data-id="element-418" />
        <Footer data-id="element-419" />
        <FloatingCTA totalPrice={totalPrice} bump1={bump1} bump2={bump2} data-id="element-420" />
        <SocialProofToast data-id="element-421" />
      </main>
    </>;
}